import React from 'react';
import { Row, Spacer } from '../../../components';
import { Typography } from '@mui/material';
import { Trans } from 'react-i18next';

interface SvgBulletRowProps {
  art: React.ReactNode;
  text: string;
}

const SvgBulletRow: React.FC<SvgBulletRowProps> = ({ art, text }) => {
  return (
    <Row style={{ alignItems: 'center' }}>
      {art}
      <Spacer width='xs' />
      <Typography
        color='secondary'
        variant='body1'
        sx={{ maxWidth: '80%', display: 'inline-block' }}>
        <Trans i18nKey={text} />
      </Typography>
    </Row>
  );
};

export default SvgBulletRow;
